import client from '../httpClient';

const updateProhibitWordsApi = (wordId, params) => {
  return client.put(`/prohibited-words/${wordId}`, JSON.stringify(params));
};

export default updateProhibitWordsApi;
